<template>
  <div class="subtitleQuickMenu" @mousedown.stop>
    <transition name="slide-left">
      <div class="container" v-show="showQuickMenu">
        <TemplateQuickMenu v-if="!$route.subtitle" @close="close"></TemplateQuickMenu>
        <VideoQuickMenu v-if="$route.subtitle" @close="close"></VideoQuickMenu>
      </div>
    </transition>
  </div>
</template>

<script>
import TemplateQuickMenu from "./templateQuickMenu";
//import TemplateQuickMenu from "../../modal/quickManu";
import VideoQuickMenu from "./videoQuickMenu";
export default {
  name: "subtitleQuickMenu",
  data() {
    return {
      showQuickMenu: false
    };
  },
  props: {},
  components: {
    TemplateQuickMenu,
    VideoQuickMenu
  },
  methods: {
    close() {
      this.showQuickMenu = false;
    }
  },
  mounted() {
    let _this = this;
    $("body").on("mousedown", e => {
      _this.showQuickMenu = false;
    });

    this.$bus.on("showQuickMenu", e => {
      _this.showQuickMenu = true;
    });
  },
  watch: {},
  computed: {}
};
</script>

<style scoped lang='scss'>
.slide-left-enter-active {
  transition: all 0.3s linear;
}
.slide-left-leave-active {
  transition: all 0.3s linear;
}
.slide-left-enter,
.slide-left-leave-to {
  transform: translateX(-100%);
}
.slide-left-enter-to,
.slide-left-leave {
  transform: translateX(0);
}

.subtitleQuickMenu {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  z-index: 20;

  .container {
    background-color: #474261;
    height: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/subtitle/quickMenu/subtitleQuickMenu.vue